// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-UserDetails-styles___detailsLoaderContainer--lWF0t {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-UserDetails-styles___syncContainer--zXtPY {
  display: flex;
  align-items: center;
  gap: 30px;
  margin: 0px 20px 10px 20px;
}

.components-UserDetails-styles___fcFieldsNotFilledError--QEydX {
  color: #318afb;
  margin: 0px 20px 10px 20px;
}

.components-UserDetails-styles___travelPolicyTabs--L3AOW {
  margin: 0;
  padding: 10px 0 0 0;
}

.components-UserDetails-styles___travelPolicyTabs--L3AOW span {
    text-transform: none;
    font-size: 17px;
  }

.components-UserDetails-styles___travelPolicyTabsContainer--YBYnW {
  margin-bottom: 20px;
}

.components-UserDetails-styles___orderIdField--lCgRl {
  max-width: 500px;
  margin-bottom: 5px;
}

.components-UserDetails-styles___syncHeader--FJvph {
  margin-left: 20px;
  margin-top: 20px;
}

.components-UserDetails-styles___syncButton--LN4Sj {
  width: 60px;
}

.components-UserDetails-styles___syncPaper--gbY30 {
  margin-bottom: 30px;
}

.components-UserDetails-styles___header--rtV9T {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___button--Pv4OS {
    height: 34px;
    font-size: 13px;
    padding: 0 16px;
  }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY {
    display: flex;
  }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___avatarContainer--I_xHP {
      margin-right: 8px;
      margin-top: 27px;
    }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___avatarContainer--I_xHP .components-UserDetails-styles___avatar--Vdto1 {
        width: 50px;
        height: 50px;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___avatarContainer--I_xHP .components-UserDetails-styles___avatarLetter--PZFx4 {
        width: 50px;
        height: 50px;
        font-size: 15px;
        color: #6d717a;
        letter-spacing: 0;
        text-align: center;
        background-color: #e0e2e6;
        text-transform: uppercase;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      -moz-column-gap: 12px;
           column-gap: 12px;
      row-gap: 8px;
    }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___travelerName--bCJF5 {
        margin: 0;
        line-height: 1.2;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___statusButton--sIN1f {
        margin: 0 0 0 8px;
        border-radius: 4px;
        text-transform: none;
        font-size: 13px;
        font-family: 'Roboto';
        font-weight: 600;
        min-width: 110px;
        height: 32px;
        padding: 0 12px;
        opacity: 1;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___statusButton--sIN1f:disabled {
          opacity: 1;
        }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___active--VRdIS {
        background: rgba(18, 218, 159, 0.1);
        border: 1px solid #12da9f;
        color: #1b2432;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___inviteSent--D4777 {
        background: rgba(49, 138, 251, 0.1);
        border: 1px solid #318afb;
        color: #1b2432;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___notInvited--k1gY4 {
        background: rgba(242, 106, 89, 0.1);
        border: 1px solid #f26a59;
        color: #1b2432;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___chips--Yauhf {
        display: flex;
        align-items: center;
        margin: 0;
        flex-wrap: wrap;
        gap: 8px;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___chip--TpL08 {
        height: 32px;
        font-size: 13px;
        color: #ffffff;
        letter-spacing: 0;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        margin: 0;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___brex--eoAyD {
        width: 59px;
        background: #e9794b;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___terminated--fWYTK {
        background: rgba(242, 106, 89, 0.1);
        border: 1px solid #f26a59;
        width: 99px;
        color: #1b2432;
        font-family: 'Roboto';
        font-weight: 600;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___terminated--fWYTK span {
          padding: 6px;
        }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___fraud--J3KWo {
        background: #fc3b60;
        width: 99px;
        color: #ffffff;
        font-family: 'Roboto';
        font-weight: 600;
        height: 32px;
        font-size: 13px;
        letter-spacing: 0;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        margin: 0;
      }

.components-UserDetails-styles___header--rtV9T .components-UserDetails-styles___avatarAndName--BsRJY .components-UserDetails-styles___nameAndBrexContainer--v1mci .components-UserDetails-styles___fraud--J3KWo span {
          padding: 6px;
        }

.components-UserDetails-styles___tabs--B5jOe,
.components-UserDetails-styles___tab--kk6Jb {
  text-transform: initial !important;
}

.components-UserDetails-styles___tabs--B5jOe {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 25px;
}

.components-UserDetails-styles___name--l1u3b {
  margin-bottom: 8px !important;
}

.components-UserDetails-styles___companyName--syBGl {
  text-align: left;
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  margin-bottom: 15px;
  display: flex;
}

.components-UserDetails-styles___link--Xydeh {
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 2px;
}

.components-UserDetails-styles___travelPolicyRulesRow--CwGtp {
  display: flex;
  flex-direction: row;
}

.components-UserDetails-styles___travelPolicyRules--tKh0P {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/UserDetails/styles.pcss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;AAMrB;;AAJE;IACE,oBAAoB;IACpB,eAAe;EACjB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AACA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AA2IrB;;AAzIE;IACE,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;AACA;IACE,aAAa;EAkIf;;AAhIE;MACE,iBAAiB;MACjB,gBAAgB;IAiBlB;;AAfE;QACE,WAAW;QACX,YAAY;MACd;;AAEA;QACE,WAAW;QACX,YAAY;QACZ,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,yBAAyB;QACzB,yBAAyB;MAC3B;;AAGF;MACE,aAAa;MACb,mBAAmB;MACnB,eAAe;MACf,qBAAgB;WAAhB,gBAAgB;MAChB,YAAY;IAqGd;;AAnGE;QACE,SAAS;QACT,gBAAgB;MAClB;;AAEA;QACE,iBAAiB;QACjB,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,qBAAqB;QACrB,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,UAAU;MAKZ;;AAHE;UACE,UAAU;QACZ;;AAGF;QACE,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;MAChB;;AAEA;QACE,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;MAChB;;AAEA;QACE,mCAAmC;QACnC,yBAAyB;QACzB,cAAc;MAChB;;AAEA;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,eAAe;QACf,QAAQ;MACV;;AAEA;QACE,YAAY;QACZ,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,SAAS;MACX;;AAEA;QACE,WAAW;QACX,mBAAmB;MACrB;;AAEA;QACE,mCAAmC;QACnC,yBAAyB;QACzB,WAAW;QACX,cAAc;QACd,qBAAqB;QACrB,gBAAgB;MAKlB;;AAHE;UACE,YAAY;QACd;;AAGF;QACE,mBAAmB;QACnB,WAAW;QACX,cAAc;QACd,qBAAqB;QACrB,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,SAAS;MAKX;;AAHE;UACE,YAAY;QACd;;AAMR;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AACA;EACE,WAAW;AACb","sourcesContent":[".detailsLoaderContainer {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.syncContainer {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin: 0px 20px 10px 20px;\n}\n\n.fcFieldsNotFilledError {\n  color: #318afb;\n  margin: 0px 20px 10px 20px;\n}\n\n.travelPolicyTabs {\n  margin: 0;\n  padding: 10px 0 0 0;\n\n  span {\n    text-transform: none;\n    font-size: 17px;\n  }\n}\n\n.travelPolicyTabsContainer {\n  margin-bottom: 20px;\n}\n\n.orderIdField {\n  max-width: 500px;\n  margin-bottom: 5px;\n}\n\n.syncHeader {\n  margin-left: 20px;\n  margin-top: 20px;\n}\n.syncButton {\n  width: 60px;\n}\n\n.syncPaper {\n  margin-bottom: 30px;\n}\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .button {\n    height: 34px;\n    font-size: 13px;\n    padding: 0 16px;\n  }\n  .avatarAndName {\n    display: flex;\n\n    .avatarContainer {\n      margin-right: 8px;\n      margin-top: 27px;\n\n      .avatar {\n        width: 50px;\n        height: 50px;\n      }\n\n      .avatarLetter {\n        width: 50px;\n        height: 50px;\n        font-size: 15px;\n        color: #6d717a;\n        letter-spacing: 0;\n        text-align: center;\n        background-color: #e0e2e6;\n        text-transform: uppercase;\n      }\n    }\n\n    .nameAndBrexContainer {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      column-gap: 12px;\n      row-gap: 8px;\n\n      .travelerName {\n        margin: 0;\n        line-height: 1.2;\n      }\n\n      .statusButton {\n        margin: 0 0 0 8px;\n        border-radius: 4px;\n        text-transform: none;\n        font-size: 13px;\n        font-family: 'Roboto';\n        font-weight: 600;\n        min-width: 110px;\n        height: 32px;\n        padding: 0 12px;\n        opacity: 1;\n\n        &:disabled {\n          opacity: 1;\n        }\n      }\n\n      .active {\n        background: rgba(18, 218, 159, 0.1);\n        border: 1px solid #12da9f;\n        color: #1b2432;\n      }\n\n      .inviteSent {\n        background: rgba(49, 138, 251, 0.1);\n        border: 1px solid #318afb;\n        color: #1b2432;\n      }\n\n      .notInvited {\n        background: rgba(242, 106, 89, 0.1);\n        border: 1px solid #f26a59;\n        color: #1b2432;\n      }\n\n      .chips {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        flex-wrap: wrap;\n        gap: 8px;\n      }\n\n      .chip {\n        height: 32px;\n        font-size: 13px;\n        color: #ffffff;\n        letter-spacing: 0;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0 16px;\n        margin: 0;\n      }\n\n      .brex {\n        width: 59px;\n        background: #e9794b;\n      }\n\n      .terminated {\n        background: rgba(242, 106, 89, 0.1);\n        border: 1px solid #f26a59;\n        width: 99px;\n        color: #1b2432;\n        font-family: 'Roboto';\n        font-weight: 600;\n\n        span {\n          padding: 6px;\n        }\n      }\n\n      .fraud {\n        background: #fc3b60;\n        width: 99px;\n        color: #ffffff;\n        font-family: 'Roboto';\n        font-weight: 600;\n        height: 32px;\n        font-size: 13px;\n        letter-spacing: 0;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0 16px;\n        margin: 0;\n\n        span {\n          padding: 6px;\n        }\n      }\n    }\n  }\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 25px;\n}\n\n.name {\n  margin-bottom: 8px !important;\n}\n\n.companyName {\n  text-align: left;\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-bottom: 15px;\n  display: flex;\n}\n\n.link {\n  cursor: pointer;\n  width: fit-content;\n  padding-left: 2px;\n}\n\n.travelPolicyRulesRow {\n  display: flex;\n  flex-direction: row;\n}\n.travelPolicyRules {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailsLoaderContainer": `components-UserDetails-styles___detailsLoaderContainer--lWF0t`,
	"syncContainer": `components-UserDetails-styles___syncContainer--zXtPY`,
	"fcFieldsNotFilledError": `components-UserDetails-styles___fcFieldsNotFilledError--QEydX`,
	"travelPolicyTabs": `components-UserDetails-styles___travelPolicyTabs--L3AOW`,
	"travelPolicyTabsContainer": `components-UserDetails-styles___travelPolicyTabsContainer--YBYnW`,
	"orderIdField": `components-UserDetails-styles___orderIdField--lCgRl`,
	"syncHeader": `components-UserDetails-styles___syncHeader--FJvph`,
	"syncButton": `components-UserDetails-styles___syncButton--LN4Sj`,
	"syncPaper": `components-UserDetails-styles___syncPaper--gbY30`,
	"header": `components-UserDetails-styles___header--rtV9T`,
	"button": `components-UserDetails-styles___button--Pv4OS`,
	"avatarAndName": `components-UserDetails-styles___avatarAndName--BsRJY`,
	"avatarContainer": `components-UserDetails-styles___avatarContainer--I_xHP`,
	"avatar": `components-UserDetails-styles___avatar--Vdto1`,
	"avatarLetter": `components-UserDetails-styles___avatarLetter--PZFx4`,
	"nameAndBrexContainer": `components-UserDetails-styles___nameAndBrexContainer--v1mci`,
	"travelerName": `components-UserDetails-styles___travelerName--bCJF5`,
	"statusButton": `components-UserDetails-styles___statusButton--sIN1f`,
	"active": `components-UserDetails-styles___active--VRdIS`,
	"inviteSent": `components-UserDetails-styles___inviteSent--D4777`,
	"notInvited": `components-UserDetails-styles___notInvited--k1gY4`,
	"chips": `components-UserDetails-styles___chips--Yauhf`,
	"chip": `components-UserDetails-styles___chip--TpL08`,
	"brex": `components-UserDetails-styles___brex--eoAyD`,
	"terminated": `components-UserDetails-styles___terminated--fWYTK`,
	"fraud": `components-UserDetails-styles___fraud--J3KWo`,
	"tabs": `components-UserDetails-styles___tabs--B5jOe`,
	"tab": `components-UserDetails-styles___tab--kk6Jb`,
	"name": `components-UserDetails-styles___name--l1u3b`,
	"companyName": `components-UserDetails-styles___companyName--syBGl`,
	"link": `components-UserDetails-styles___link--Xydeh`,
	"travelPolicyRulesRow": `components-UserDetails-styles___travelPolicyRulesRow--CwGtp`,
	"travelPolicyRules": `components-UserDetails-styles___travelPolicyRules--tKh0P`
};
module.exports = ___CSS_LOADER_EXPORT___;
